import script from "./ResellerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ResellerPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__